import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchMotoristaApi } from '../../services/motoristaAuth';

const MotoristaHistorico: React.FC = () => {
  const navigate = useNavigate();
  const [checklists, setChecklists] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => { loadChecklists(1); }, []);

  const loadChecklists = async (p: number) => {
    try {
      setIsLoading(true);
      const res = await fetchMotoristaApi(`/checklists?page=${p}&limit=15`);
      if (res.success && res.data) {
        const items = res.data.checklists || [];
        setChecklists(prev => p === 1 ? items : [...prev, ...items]);
        setHasMore(items.length === 15);
        setPage(p);
      }
    } catch (err) {
      console.error('Erro ao carregar historico:', err);
    } finally { setIsLoading(false); }
  };

  const formatDate = (d: string) => d ? new Date(d).toLocaleDateString('pt-BR') : '-';
  const formatTime = (d: string) => d ? new Date(d).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <div style={{ minHeight: '100vh', background: '#f5f6fa' }}>
      <div style={{ background: '#04C64F', color: 'white', padding: '15px 20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
        <button onClick={() => navigate('/motorista')} style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.2rem', cursor: 'pointer' }}>
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 style={{ margin: 0, fontSize: '1.1rem' }}>Historico de Checklists</h1>
      </div>

      <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
        {checklists.length === 0 && !isLoading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#95a5a6' }}>
            <i className="fas fa-clipboard-list" style={{ fontSize: '48px', marginBottom: '15px', display: 'block' }}></i>
            <p>Nenhum checklist realizado ainda.</p>
          </div>
        ) : (
          <>
            {checklists.map((c: any) => (
              <div key={c.id} style={{ background: 'white', borderRadius: '12px', padding: '15px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                  <strong style={{ color: '#2c3e50' }}>{c.veiculo_placa || 'S/Veiculo'}</strong>
                  <span style={{
                    padding: '4px 10px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: '600',
                    background: c.status === 'concluido' ? '#e8f5e9' : '#fff3e0',
                    color: c.status === 'concluido' ? '#2e7d32' : '#e65100'
                  }}>
                    {c.status === 'concluido' ? 'Concluido' : c.status}
                  </span>
                </div>
                <div style={{ fontSize: '0.85rem', color: '#7f8c8d' }}>
                  <p style={{ margin: '4px 0' }}>
                    <i className="fas fa-calendar" style={{ marginRight: '6px', width: '14px' }}></i>
                    {formatDate(c.data_realizacao)} {formatTime(c.data_realizacao)}
                  </p>
                  {c.veiculo_marca && (
                    <p style={{ margin: '4px 0' }}>
                      <i className="fas fa-car" style={{ marginRight: '6px', width: '14px' }}></i>
                      {c.veiculo_marca} {c.veiculo_modelo}
                    </p>
                  )}
                  {c.odometro && (
                    <p style={{ margin: '4px 0' }}>
                      <i className="fas fa-tachometer-alt" style={{ marginRight: '6px', width: '14px' }}></i>
                      {new Intl.NumberFormat('pt-BR').format(c.odometro)} km
                    </p>
                  )}
                  <p style={{ margin: '4px 0' }}>
                    <i className="fas fa-tag" style={{ marginRight: '6px', width: '14px' }}></i>
                    {c.tipo || 'Checklist'}
                  </p>
                </div>
              </div>
            ))}

            {hasMore && (
              <button
                onClick={() => loadChecklists(page + 1)}
                disabled={isLoading}
                style={{
                  width: '100%', padding: '14px', background: 'white', border: '2px solid #04C64F',
                  borderRadius: '12px', color: '#04C64F', fontWeight: '600', cursor: 'pointer', marginTop: '10px'
                }}
              >
                {isLoading ? 'Carregando...' : 'Carregar mais'}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MotoristaHistorico;
